module.exports = __webpack_public_path__ + "img/swiper3.76565936.png";